// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"apps_watchtower_src_app_auth0-callback_auth0-callback_module_ts":"1cbc1784815926ae","apps_watchtower_src_app_error_error_module_ts":"f81684197587c8d9","apps_watchtower_src_app_watch-tower_watch-tower_module_ts":"8974fa9256e61044"}[chunkId] + ".js";
};